import { SUBURBAN } from 'shared/constants/suburban';
import { selectOffer } from 'shared/selectors';
import { IState } from 'shared/store';

export const isSuburbanSelector = (state: IState) => {
  const offer = selectOffer(state);

  return SUBURBAN.includes(offer.category);
};
